import {Tooltip} from "antd"
import {forEach} from "lodash"
import cx from "classnames"
import {Icon} from "components/Icon"
import {RemarkIndicator} from "./RemarkIndicator"
import styles from "./item.module.css"
import {downloadLink} from "helpers"

type Props = {
    field: any
    onChangeRemarkField: (fieldId: string, comment: string) => void
}

export function File(props: Props) {
    const {field, onChangeRemarkField} = props
    const {width, height} = field.placeInformation
    const style: any = {width, height}

    const downloadAllFiles = () => {
        forEach(field.value, (fileUrl) => downloadLink(fileUrl))
    }

    const renderBody = () => {
        if (!field.value) {
            return null
        }

        return (
            <Tooltip title="Click this icon to download file">
                <button
                    className={styles.downloadBtn}
                    style={{height}}
                    onClick={(event) => {
                        event.stopPropagation()
                        downloadAllFiles()
                    }}>
                    <Icon icon="FILE" className={styles.fileAnswerIcon} />
                </button>
            </Tooltip>
        )
    }

    return (
        <RemarkIndicator field={field} onChangeRemarkField={onChangeRemarkField}>
            <div className={cx(styles.actionItem, styles.flexCenter)} style={style}>
                {renderBody()}
            </div>
        </RemarkIndicator>
    )
}
